<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Create New OPB Company</h2>
  </div>
  <app-opb-company-form />
</div>
